import IeltWrite from 'app/components/tests/Ielts/IeltWrite';
import IeltSpeak from 'app/components/tests/Ielts/IeltSpeak';
import IeltRead from 'app/components/tests/Ielts/IeltRead';
import * as categoryConst from 'app/constants/categories';
import { AppStoreState } from 'app/redux/store';
import { Question, Passage } from 'types/test';
import { useSelector } from 'react-redux';

interface IeltFormProps {
  passagesOfUser: Passage[];
  setPassagesUser: React.Dispatch<React.SetStateAction<Passage[]>>
  confirmIsReady: () => void;
  handleChangeQuestion: (value: string | null, question: Question) => void
}

const IeltForm = (props: IeltFormProps) => {
  const { test } = useSelector((state: AppStoreState) => state.test);

  return (
    <>
      {test.category_id == categoryConst.IELT_WRITE &&
        <IeltWrite
          confirmIsReady={props.confirmIsReady}
          passagesOfUser={props.passagesOfUser}
          setPassagesUser={props.setPassagesUser}
        />
      }

      {test.category_id == categoryConst.IELT_SPEAK && (
        <IeltSpeak />
      )}

      {test.category_id == categoryConst.IELT_READ &&
        <IeltRead
          confirmIsReady={props.confirmIsReady}
          handleChange={props.handleChangeQuestion}
        />
      }
    </>
  )
}

export default IeltForm;
